import type {FarmEvent} from './model';

export const FEED_CHANGE_CATEGORY='cambioAlimento';
export const FEED_CHANGE_LABEL='Cambio de alimento';

/** Derived from existing text: no migration or rewriting of protocol records is needed. */
export function protocolCategory(name:string,detail=''):typeof FEED_CHANGE_CATEGORY|null {
  const text=`${name}\n${detail}`.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLocaleLowerCase('es');
  return /\bcambios?\s+(?:de\s+(?:la\s+)?)?(?:alimentos?|alimentacion)\b/.test(text)?FEED_CHANGE_CATEGORY:null;
}

/** Categories supplement the original event type; they never replace partos or protocolos. */
export function isFeedChangeEvent(event:FarmEvent):boolean {
  return ['protocolo','parto'].includes(event.tipo)&&protocolCategory(event.action||'',event.detail)===FEED_CHANGE_CATEGORY;
}
